import { Component, Input, Output, EventEmitter } from '@angular/core'
import { Plan, BillingFrequency } from '../../types'
import { prettyDollars, prettyCents } from '../../logic/pricing'
import { BaseComponent } from '../../components/base.component'
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations'

@Component({
  styles: [`
    :host {
      display: block;
      height: 100%;
      width: 100%;
    }
    .agency-buffer {
      margin-bottom: 70px;
    }
  `],
  animations: [
    trigger('leftVisibility', [
      state('false', style({transform: 'translateX(-200%)', height: '0', display: 'none'})),
      state('true', style({transform: 'translateX(0)', height: '*'})),
      transition('1 => 0', animate('300ms ease')),
      transition('0 => 1', animate('300ms ease'))
    ]),
    trigger('rightVisibility', [
      state('false', style({transform: 'translateX(200%)', height: '0', display: 'none'})),
      state('true', style({transform: 'translateX(0)', height: '*'})),
      transition('1 => 0', animate('300ms ease')),
      transition('0 => 1', animate('300ms ease'))
    ])
  ],
  selector: 'video-plan-form',
    template: `
      <div class="row my-3 customer-signup">
        <div class="col text-center">
          <ng-template [ngIf]="showPlansSelection">
            <div class="d-flex justify-content-center text-center mt-4 mb-1">
              <div class="registration-buttons">
                <div class="registration-button active p-4">
                  <h4 class="mb-4">Verblio Vids</h4>
                  <div class="small">
                    <div class="price">
                      <span class="currency">$</span>
                      <span class="dollars">{{prettyDollars(plan?.price)}}</span>
                      <span class="cents">{{prettyCents(plan?.price)}}</span>
                      <span class="per-month" [style.top]="'0.8em'" [style.font-size]="'0.6em'">/video</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="learnMore" class="d-flex justify-content-center text-center mb-2">
              <a href="javascript:false" (click)="showLearnMoreModal()" class="text-small">Learn more</a>
            </div>
          </ng-template>
          <div class="d-flex justify-content-center my-3">
            <plan-page-picker [type]="'numberOfPosts'" [value]="quantity" (valueChange)="setQuantity($event)"></plan-page-picker>
          </div>
          <div class="my-4 d-flex flex-row justify-content-center align-items-center">
            <div>
              <strong class="pr-2">Total:</strong>
            </div>
            <div class="small">
              <span class="price">
                <span class="currency">$</span>
                <span class="dollars">{{prettyDollars(plan?.price * quantity)}}</span>
                <span class="cents">{{prettyCents(plan?.price * quantity)}}</span>
                <span class="per-month" [style.top]="'0.8em'" [style.font-size]="'0.6em'">/month</span>
              </span>
            </div>
          </div>
          <button *ngIf="buttonText"
            type="submit"
            class="btn btn-lg btn-primary horizontal-padding"
            [disabled]="saving"
            (click)="onSubmit()">
            {{buttonText}}
          </button>
        </div>
        <new-video-subscription-learn-more-modal *ngIf="learnMoreVisible" width="600" (close)="learnMoreVisible = false"></new-video-subscription-learn-more-modal>
      </div>
    `
})
export class VideoPlanFormComponent extends BaseComponent {
  @Input() customerId: number;
  @Input() plans: Plan[] = [];
  @Input() quantity: number = 4;
  @Input() buttonText: string;
  @Input() learnMore: boolean = true;
  @Input() showPlansSelection: boolean = true
  @Output() onChangeQuantity: EventEmitter<number> = new EventEmitter();
  @Output() submit: EventEmitter<VideoPlanFormOutput> = new EventEmitter<VideoPlanFormOutput>()
  plan: Plan
  billingFrequency: BillingFrequency = 'monthly';
  email: string;
  saving: boolean = false;
  learnMoreVisible: boolean = false;

  ngOnChanges(): void {
    this.plan = this.plans.find(p => p.code === 'video')
  }

  onSubmit(): void {
    // navigate to rails plan change summary
    this.submit.emit({
      customer: {
        id: this.customerId,
        subscription: {
          quantity: this.quantity,
          plan: {
            code: this.plan.code
          },
          planAddOns: []
        }
      }
    })
  }

  setQuantity(q: number): void {
    this.quantity = q
    this.onChangeQuantity.emit(q)
  }

  prettyCents = prettyCents;
  prettyDollars = prettyDollars;

  showLearnMoreModal(): void {
    if (this.learnMore) this.learnMoreVisible = true
  }
}

export interface VideoPlanFormOutput {
  customer: {
    id: number
    subscription: {
      quantity: number
      plan: {
        code: string
      },
      planAddOns: any[]
    }
  }
}
